import { render, staticRenderFns } from "./rencai.vue?vue&type=template&id=46b6b1ad&scoped=true&"
import script from "./rencai.vue?vue&type=script&lang=js&"
export * from "./rencai.vue?vue&type=script&lang=js&"
import style0 from "./rencai.vue?vue&type=style&index=0&id=46b6b1ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6b1ad",
  null
  
)

export default component.exports